import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayName'
})
export class DisplayNamePipe implements PipeTransform {

  transform(value: any[], field: string, displayKey: string, displayValue: string): any {
    const items = value.filter(m => m[field] === displayKey)
    if (items.length > 0) return items[0][displayValue]
    return null;
  }

}
